import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const RangeValidationModal = props => {

  const buttonConfig = {
    primary: {
      label: 'KAPAT',
      onClick: props.onPrimaryButtonClick
    }
  };

  return (
    <Message type="none" buttonConfig={ buttonConfig } >
      { props.errorMessage }
    </Message>
  );
};

RangeValidationModal.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default RangeValidationModal;
